import type { CSSProperties } from 'react';
interface HUDProps {
  score: number;
  bestScore: number;
  onStop: () => void;
}
export function HUD({ score, bestScore, onStop }: HUDProps) {
  return (
    <div className="absolute inset-0 pointer-events-none z-10">
      {/* Score panel - top center */}
      <div className="absolute top-4 left-1/2 -translate-x-1/2">
        <div className="bg-amber-50/80 backdrop-blur-sm rounded-2xl px-6 py-3 shadow-lg border border-amber-200/50">
          <div className="flex flex-col items-center gap-1">
            <div className="flex items-center gap-3">
              <span className="text-2xl" style={{ WebkitTapHighlightColor: 'transparent' } as CSSProperties}>⭐</span>
              <span
                className="text-3xl font-bold text-amber-800 tabular-nums"
                style={{ fontVariantNumeric: 'tabular-nums' } as CSSProperties}
              >
                {score}
              </span>
            </div>
            {bestScore > 0 && (
              <div className="text-sm text-amber-600/70 flex items-center gap-1">
                <span>Best:</span>
                <span className="font-semibold tabular-nums">{bestScore}</span>
              </div>
            )}
          </div>
        </div>
      </div>
      {/* Stop button - top right */}
      <div className="absolute top-4 right-4 pointer-events-auto">
        <button
          onClick={onStop}
          className="w-12 h-12 rounded-full bg-amber-100/80 backdrop-blur-sm shadow-md border-2 border-amber-300 flex items-center justify-center text-amber-700 font-bold text-lg transition-all duration-150 active:scale-95 hover:bg-amber-200"
          style={{
            WebkitTapHighlightColor: 'transparent',
            userSelect: 'none',
            touchAction: 'manipulation',
          } as CSSProperties}
          aria-label="Stop game"
        >
          ⏹
        </button>
      </div>
    </div>
  );
}